var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkippayCircles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 73,
  fill: "none",
  viewBox: "0 0 120 73"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.165 24.2c-3.352 5.807-10.777 7.797-16.584 4.445-5.806-3.353-7.796-10.778-4.444-16.584 3.353-5.807 10.778-7.797 16.584-4.444 5.808 3.352 7.797 10.777 4.444 16.584"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.597 33.985a7.285 7.285 0 0 1-9.953 2.666 7.285 7.285 0 1 1 7.286-12.619 7.286 7.286 0 0 1 2.667 9.953"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.114 54.638c-10.058 17.42-32.333 23.389-49.753 13.331s-23.388-32.332-13.33-49.752C62.087.797 84.361-5.172 101.782 4.886s23.388 32.332 13.331 49.752"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h120v73H0z"
})))));
export default SvgSkippayCircles;